module.exports = __webpack_public_path__ + "static/ServiceDoc-41990a2272ba64a54b6aa7f27234f53c.png";